import React from 'react'
import './style.css'

const Button = ({ children, buttonType, ...props }) => (
	<button className={buttonType} {...props}>{children}</button>
)

export default Button
